Vue.component('webchat-group', require('./WebChatGroup').default);
Vue.component('webchat-group-list', require('./WebChatGroupList').default);
Vue.component('webchat-list', require('./WebChatList').default);
Vue.component('webchat-list-item', require('./WebChatListItem').default);
Vue.component('webchat', require('./WebChat').default);
Vue.component('webchat-page', require('./WebChatPage').default);

